export const THREE_HOUR_DELIVERY_PRODUCT_ID = 7;
export const WALLS_PRODUCT_IDS = [33, 34, 35, 51, 54, 78, 79, 85, 87, 86, 88, 107, 108];
export const WHOLE_HOME_PRODUCT_IDS = [99, 111];
export const SOLAR_PRODUCT_TYPE = 6;
// #genai - ESX (Product 114) compatibility - only compatible with these primary products
export const ESX_COMPATIBLE_PRODUCTS = [106, 111];
export const ROOF_PRODUCTS = 'Roof Products';
export const SOLAR_PRODUCTS = 'Solar Products';
export const WHOLE_HOME_PRODUCTS = 'Full House Products';
export const WALLS_PRODUCTS = 'Walls Products';
export const OTHER_PRODUCTS = 'Other Products';
export const DATA_PRODUCTS = 'Data Products';
export const REGULAR = 'Regular';
export const EXPRESS = 'Express';
export const QUICK = 'Quick';
export const THREE_HOUR = '3-Hour';
